var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view"},[_c('img',{attrs:{"src":require("@/assets/accroche.jpg"),"alt":""}}),_c('img',{attrs:{"id":"ll","src":require("@/assets/laurent_luqei.jpg"),"alt":""}}),_c('landing-auth')],1)}
var staticRenderFns = []

export { render, staticRenderFns }